import axios from "axios";
import { getAccessToken } from "./utils.js";
import { getUrl } from "./urls";
import { toast } from "react-toastify";
import { getRawDataUrlParams, getDownloadParams } from "./rawDataActionUtils";
import { getPostInfo } from "../components/MainContent/RawData/RawDataCard/postInfoUtils";
import { fetchMetaData } from "../actions/globalAction";
import moment from "moment";
export const FETCH_VIRAL_NOW_DATA = "FETCH_VIRAL_NOW_DATA";
export const FETCH_PREDICTED_VIRALITY_DATA = "FETCH_PREDICTED_VIRALITY_DATA";
export const FETCH_ADMIN_TH_VALUE = "FETCH_ADMIN_TH_VALUE";

export function fetchViralNowData(
    filter,
    offset,
    sortOption,
    influencers,
    sentiment,
    sentimentType,
    media,
    channel,
    postType,
    exclusion,
    sampling,
    searchDataType,
    allDataCharts,
) {
    let data = getRawDataUrlParams(
        filter,
        offset,
        sortOption,
        influencers,
        sentiment,
        sentimentType,
        media,
        channel,
        postType,
        exclusion,
        sampling,
        searchDataType,
        allDataCharts,
    );
    let current_id = window.location.hash.split("/")[2];
    let all_filters = JSON.parse(localStorage.getItem("filters"));
    let view_name = all_filters.filter((elem) => elem.id === parseInt(current_id) && elem.view_type === "system");
    if (
        view_name.length &&
        (view_name[0].name.toLowerCase() === "social" || view_name[0].name.toLowerCase() === "social+news" || view_name[0].name.toLowerCase() === "news")
    ) {
        data.append("exclude_account_type", "1,2,3");
        data.append("fields_not_exist", "account_types");
    }
    let req = axios({
        method: "post",
        url: getUrl("raw_data"),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    }).then((res) => ({ ...res.data, offset }));
    return {
        type: FETCH_VIRAL_NOW_DATA,
        payload: req,
    };
}

export function fetchPredictedViralityData(
    filter,
    offset,
    sortOption,
    influencers,
    sentiment,
    sentimentType,
    media,
    channel,
    postType,
    exclusion,
    sampling,
    searchDataType,
    allDataCharts,
) {
    let data = getRawDataUrlParams(
        filter,
        offset,
        sortOption,
        influencers,
        sentiment,
        sentimentType,
        media,
        channel,
        postType,
        exclusion,
        sampling,
        searchDataType,
        allDataCharts,
    );
    let current_id = window.location.hash.split("/")[2];
    let all_filters = JSON.parse(localStorage.getItem("filters"));
    let view_name = all_filters.filter((elem) => elem.id === parseInt(current_id) && elem.view_type === "system");
    if (
        view_name.length &&
        (view_name[0].name.toLowerCase() === "social" || view_name[0].name.toLowerCase() === "social+news" || view_name[0].name.toLowerCase() === "news")
    ) {
        data.append("exclude_account_type", "1,2,3");
        data.append("fields_not_exist", "account_types");
    }
    // getUrl('raw_data')
    const url = `https://api2.radarr.com/v7/search?access-token=${getAccessToken()}`;
    let req = axios({
        method: "post",
        url,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    }).then((res) => ({ ...res.data, offset }));

    return {
        type: FETCH_PREDICTED_VIRALITY_DATA,
        payload: req,
    };
}

export function setViralityThresholdValue(params) {
    return function (dispatch) {
        axios
            .post(getUrl("setViralityThreshold"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch(fetchMetaData());
                toast.success("Settings saved successfully");
            })
            .catch((err) => toast.error("There was an error saving your changes. Please try again"));
    };
}
export function fetchComapnyMetaData() {
    let res = axios
        .get(getUrl("comapnyMetaApi"), {
            cache: false,
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
    return {
        type: "FETCH_ADMIN_TH_VALUE",
        payload: res,
    };
}
